export default __webpack_public_path__ + "static/media/learningEmpty.a8aa9a4a.svg";